"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdpAxiosClient = void 0;
const axios_helper_1 = require("@vacasa/axios-helper");
const _ = require("lodash");
const core_1 = require("@vacasa/core");
const idp_auth_1 = require("./idp.auth");
class IdpAxiosClient {
    constructor(idpConfiguration, serviceConfiguration, loggingService) {
        this.idpConfiguration = idpConfiguration;
        this.serviceConfiguration = serviceConfiguration;
        this.loggingService = loggingService;
        this.logger = loggingService === null || loggingService === void 0 ? void 0 : loggingService.getLogger("IdpAxiosClient");
        this.idpAuth = new idp_auth_1.IdpAuth(loggingService);
    }
    async authInstance(backOff = 1000, maxAttempts = 5) {
        return axios_helper_1.getExtendedAxios({
            mediator: {
                getAuthCredentials: async () => {
                    return {
                        headers: {
                            "accept-language": "en-US",
                            authorization: "Bearer " +
                                (await this.getToken(Array.isArray(this.serviceConfiguration.audience)
                                    ? this.serviceConfiguration.audience.join(",")
                                    : this.serviceConfiguration.audience)),
                            "Content-Type": "application/vnd.api+json",
                        },
                    };
                },
            },
            retrier: {
                getBackoff: (error, attempts) => {
                    var _a, _b;
                    if (attempts >= maxAttempts) {
                        return -1;
                    }
                    (_a = this.logger) === null || _a === void 0 ? void 0 : _a.error("Idp auth failed", {
                        audience: this.serviceConfiguration.audience,
                        error: error && error.toString(),
                    });
                    const status = _.get(error, "response.status", 0);
                    if (status == 400 || status == 404) {
                        return -1;
                    }
                    else if (status == 401 || status == 403) {
                        (_b = this.logger) === null || _b === void 0 ? void 0 : _b.error("Idp auth failed", {
                            audience: this.serviceConfiguration.audience,
                            error: error && error.toString(),
                        });
                    }
                    return typeof backOff == "function" ? backOff(attempts) : backOff;
                },
            },
        });
    }
    async getToken(audience) {
        var _a, _b;
        try {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info(`token not found in cache for audience ${audience} `);
            const token = await this.idpAuth.getToken(this.idpConfiguration, this.serviceConfiguration);
            return token.accessToken;
        }
        catch (error) {
            (_b = this.logger) === null || _b === void 0 ? void 0 : _b.error("Error getting idp token for audience", {
                audience: this.serviceConfiguration.audience,
                error: error && error.toString(),
            });
            throw error;
        }
    }
}
__decorate([
    core_1.MemoizeExpiring(3600000),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], IdpAxiosClient.prototype, "getToken", null);
exports.IdpAxiosClient = IdpAxiosClient;
//# sourceMappingURL=idp-axios-client.js.map